import Swiper from 'swiper';
import { Navigation, EffectFade, Zoom } from 'swiper/modules';
import { getOptionsFromJsonString } from "../../../default/global/js//utilities/options";

Swiper.use([Navigation, EffectFade, Zoom]);

function buildItemcardMainSwiper(el, options = {}, initialized = () => {}) {
    const swiper = new Swiper(el, {
        speed: options.eff_interval,
        effect: 'fade',
        allowTouchMove: true,
        zoom: {
            maxRatio: 3,
            minRatio: 1,
            toggle: false,
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
        on: {
            init() {
                const swiperInstance = this;
                swiperInstance.slides.forEach((slide) => {
                    const img = slide.querySelector('.swiper-zoom-target');
                    if (img) {
                        let startTime = 0;
                        let startX = 0;
                        let startY = 0;
                        let hasMoved = false;

                        const handlePointerDown = (e) => {
                            startTime = Date.now();
                            startX = e.clientX;
                            startY = e.clientY;
                            hasMoved = false;
                        };

                        const handlePointerMove = (e) => {
                            const deltaX = Math.abs(e.clientX - startX);
                            const deltaY = Math.abs(e.clientY - startY);

                            if (deltaX > 3 || deltaY > 3) {
                                hasMoved = true;
                            }
                        };

                        const handlePointerUp = (e) => {
                            const duration = Date.now() - startTime;
                            const deltaX = Math.abs(e.clientX - startX);
                            const deltaY = Math.abs(e.clientY - startY);

                            if (duration < 300 && !hasMoved && deltaX < 5 && deltaY < 5 &&
                                slide.classList.contains('swiper-slide-active')) {

                                swiperInstance.zoom.toggle();
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        };

                        img.addEventListener('pointerdown', handlePointerDown);
                        img.addEventListener('pointermove', handlePointerMove);
                        img.addEventListener('pointerup', handlePointerUp);

                        img.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    }
                });
                initialized();
            },

            slideChange() {
                this.zoom.out();
                this.allowTouchMove = true;
            },

            zoomChange(swiper, scale) {
                if (scale > 1) {
                    this.allowTouchMove = true;
                }
            }
        },
    });

    return swiper;
}

export function initItemcardImages() {
    const wrapper = document.querySelector('.js-itemcardImages');
    if (!wrapper) return;

    const mainImages = wrapper.querySelector('.js-itemcardImagesMain');
    const options = getOptionsFromJsonString(wrapper.getAttribute('data-options'), {
        eff_interval: 300,
        directionBreakpoint: GLOBALS.gridBreakpoints.sm - 1,
    });

    if (!mainImages) {
        console.error('Main Images not found');
        return;
    }

    let swiper = null;
    let lastWidth = wrapper.offsetWidth;
    let isInitializing = false;

    function initSwiper() {
        if (isInitializing) return;

        isInitializing = true;

        if (swiper) {
            try {
                swiper.destroy(true, true);
            } catch (e) {
                console.warn('Error destroying swiper:', e);
            }
            swiper = null;
        }

        wrapper.classList.remove('is-loading', 'initialized');

        setTimeout(() => {
            try {
                wrapper.classList.add('is-loading');
                swiper = buildItemcardMainSwiper(mainImages, options, function () {
                    setTimeout(() => {
                        wrapper.classList.remove('is-loading');
                        wrapper.classList.add('initialized');
                        isInitializing = false;
                    }, 200);
                });
            } catch (e) {
                console.error('Error initializing swiper:', e);
                isInitializing = false;
            }
        }, 10);
    }

    initSwiper();

    let resizeTimer = null;

    function handleResize() {
        const newWidth = wrapper.offsetWidth;
        if (Math.abs(newWidth - lastWidth) > 10) {
            lastWidth = newWidth;

            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }

            resizeTimer = setTimeout(function() {
                initSwiper();
                resizeTimer = null;
            }, 250);
        }
    }

    window.addEventListener('resize', handleResize);

    if ('onorientationchange' in window) {
        window.addEventListener('orientationchange', function() {
            setTimeout(handleResize, 100);
        });
    }
}